import { reactive } from "vue";

export const quotationState = reactive({
  currentQuotationId: undefined,
  revisionId: "0",
  isSend: false,
  currentMiddleColView: "preview",
  isUnSaved: false,
});
